import _ from 'underscore'

const staticRoot = process.env.PUBLIC_URL + '/static/';

var api = {
    root: "/client",
    init_data: "init_data.json",
    // upload_token: 'init_data/upload_token.json',
    upolad_token: 'init_data/upload_info.json', // 新的
    msg: {
        list: "sessions/messages.json",
        save: "messages.json"
    },
    group: {
        list: "groups.json",
        save: "groups.json"
    },
    session: {
        get: 'sessions/{{id}}.json',
        save: "sessions.json",
        quit: "sessions/quit.json",
        close: "sessions/close.json",
        active: "sessions/selected.json"
    }
}

function pathJoin() {
    var arr = [];
    _.each(arguments, (path, index) => {
        let reg = new RegExp((index ? "(^[/\]+)|" : "") + "([/\]+$)", "g");
        path && arr.push(path.replace(reg, ''));
    });
    return arr.join('/');
}

export var urls = {
    staticRoot,
    jsRoot: staticRoot + 'js/',
    cssRoot: staticRoot + 'css/',
    imageRoot: staticRoot + 'images/',
    mp3Root: staticRoot + 'mp3/',
    api,
    pathJoin,
    setApiRoot(uri) {
        api.root = pathJoin(uri, "client");
    }
}


// WEBPACK FOOTER //
// ./src/utils/urls.js